const styles = (theme) => ({
	boxCustomLabel: {
		bgcolor: theme.palette.paletteCharts.lineCharts,
		padding: "8px",
		borderRadius: "8px",
		boxShadow: `0px 2px 4px ${theme.palette.colors.black.darker}66`,
		minWidth: "120px",
		minHeight: "48px",
	},
	boxCOntainer: {
		height: 300,
		width: "100%",
	},
});

export default styles;
